<template>
    <div>
        <setting-with-checkbox
            v-model="twinSelected"
            :options="[{
                value: 1,
                name: 'twinSelected',
                label: twin.name,
                valuePrice: getTwinMonthlyPrice(twin),
            }]"
            :title="lang('TV i fler rum','TV in several rooms')"
            :description="translation('addon_tv_twin_expl')"
            :class="{ 'border-b-0': twinSelected }"
        />

        <setting-with-radio
            v-if="twinSelected && twinCampaigns.length"
            v-model="localSelectedTwin"
            :options="twinCampaignOptions"
            :title="lang('HD-box','HD box')"
            :description="translation('addon_tv_twin_hd_box_expl')"
            :class="{ 'border-b-0': selectedTwinCampaign }"
            @changed="(val) => $emit('input', val)"
        />
        <setting-with-text
            v-else-if="twinSelected && twin.hd_box.twin_is_collective"
            :title="lang('HD-box','HD box')"
        >
            <div class="font-bold text-sm text-neutral-darker lg:w-2/5">
                <div class="bg-neutral-lighter rounded-lg py-md px-lg flex items-center justify-start">
                    <div class="text-lg text-success mr-lg">
                        <font-awesome-icon icon="check-circle" />
                    </div>
                    <div class="max-w-xs text-sm font-semibold">
                        <span>{{ lang('Du har redan en HD-box från Ownit','You already own a HD box from ownit') }}!</span>
                    </div>
                </div>
            </div>
        </setting-with-text>

        <setting-with-checkbox
            v-if="hardDrive && (selectedTwinCampaign || (twinSelected && ! twinCampaigns.length))"
            v-model="hardDriveSelected"
            :options="[{
                value: 1,
                name: 'hardDriveSelected',
                label: hardDrive.name,
                valuePrice: format_sek(hardDrive.price),
            }]"
            :title="lang('Inspelningsbar HD-box','Recordable HD box')"
            :description="hardDrive.description"
        />
    </div>
</template>
<script>
    import SettingWithCheckbox from '../../Settings/SettingWithCheckbox';
    import SettingWithRadio from '../../Settings/SettingWithRadio';
    import SettingWithText from '../../Settings/SettingWithText';

    export default {
        components: {
            SettingWithCheckbox,
            SettingWithRadio,
            SettingWithText,
        },
        model: {
            prop: 'selectedTwinCampaign',
            event: 'input',
        },
        props: {
            selectedTwinCampaign: {
                type: Number,
                required: false,
                default: null,
            },
            twinCampaigns: {
                type: Array,
                required: true,
            },
            twin: {
                type: Object,
                required: true,
            },
            hardDrive: {
                type: Object,
                required: false,
                default: null,
            },
        },
        data() {
            return {
                twinSelected: false,
                hardDriveSelected: false,
            };
        },
        computed: {
            twinCampaignOptions() {
                return this.twinCampaigns.map((campaign) => {
                    return {
                        value: campaign.article_id,
                        name: 'twinCampaign',
                        placeholder: campaign.name,
                        price_label: format_sek(campaign.start_fee),
                    };
                });
            },
            localSelectedTwin: {
                get() {
                    return this.selectedTwinCampaign;
                },
                set(localValue) {
                    this.$emit('input', localValue);
                },
            },
        },
        watch: {
            twinSelected(newValue) {
                // Ensures that the twin campaign is unset if the twin selected
                // is false so we don't accidentally order it for the customer.
                if (! newValue) {
                    this.$emit('input', null);
                    this.hardDriveSelected = false;
                    this.localSelectedTwin = null;
                }

                if (this.twinCampaigns.length) {
                    this.localSelectedTwin = this.twinCampaigns[0].article_id;
                }

                this.$emit('twinSelected', newValue);
            },
            hardDriveSelected(newValue) {
                this.$emit('hardDriveSelected', newValue);
            },
        },
        methods: {
            getTwinMonthlyPrice(twin) {
                if (twin.is_collective) {
                    return `${format_sek_per_month(0)} (${lang('ingår', 'included')})`;
                }

                return format_sek_per_month(twin.monthly_price);
            },
        },
    };
</script>